/**
 * @flow
 */

import Orchestrator from './orchestrator';
import * as presence from 'lib/presence';
import {
  addClickHandler,
  triggerOpen,
  registerWidget,
  replaceEmbed,
  reloadWidget
} from './plugins';

export default function bootstrap() {
  let orchestrator: Orchestrator;

  if (!window.$u || !window.$u.orchestrator) {
    orchestrator = new Orchestrator();
    window.$u = {
      orchestrator,
      open: orchestrator.showCheckout,
      reload: reloadWidget(orchestrator),
      // For a host that renders its own event page (fan's EDP); pinging through
      // this module lets the orchestrator pause it while checkout is open.
      presence: {
        start: (target: string): void => presence.start(target, 'edp'),
        stop: (target: string): void => presence.stop(target)
      }
    };

    // plugins that meant to be executed once
    addClickHandler(orchestrator);
    triggerOpen(orchestrator);
    replaceEmbed(orchestrator);
  }

  else {
    orchestrator = window.$u.orchestrator;
  }

  // plugins that can be executed multiple times
  registerWidget(orchestrator);
}

bootstrap();



// WEBPACK FOOTER //
// ./src/bootstrap/index.js